import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconCalendarEvent } from "@tabler/icons-react"
import { EventDateStatus } from "@love-irish/resource-calendar-date-range"
import BaseListItem from "../base"

export interface CalendarEventListItemProps {
  item: Record<string, any>
  className?: string
  footer?: React.ReactNode
}

// The list-item for a calendar-event collection (Collection::CalendarEvent): like the event item, but
// keyed off the collection's own date range (startsAt/endsAt) so it shows the live event status
// (happening now / upcoming / past). The status sits with the media block for now.
export const CalendarEventListItem: React.FC<CalendarEventListItemProps> = ({
  item,
  className,
  footer,
}) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconCalendarEvent}
    typeLabel="Calendar event"
    testId="calendar-event-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.ATTEND }}
    media={
      <div className="space-y-3">
        {(item.startsAt || item.endsAt) && (
          <EventDateStatus
            startsAt={item.startsAt}
            endsAt={item.endsAt}
            shortFormat
          />
        )}
        {(item.imageUrl || item.thumbnailUrl) && (
          <a href={item.path}>
            <img
              src={item.thumbnailUrl || item.imageUrl}
              alt={item.name}
              className="max-w-[100px] rounded-xl"
            />
          </a>
        )}
      </div>
    }
  />
)

export default CalendarEventListItem
